<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">模板</div>
    <div class="third-title"><span>模板样式</span></div>
    <div class="order-detail-basic">
      <el-form :model="hemorrhageInfo" label-width="100px" :rules="rules" ref="formRef">
        <el-form-item label="模板缩略图:">
          <div style="width:170px;height:170px;border:1px solid #000;margin:5px 5px 0 0;">
            <img src="" alt="">
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round @click="this.$router.go(-1)">审核拒绝</el-button>
      <el-button round type="primary" @click="this.$router.go(-1)">审核通过</el-button>
    </div>
  </div>
</template>
 <script>
import { bleedDetail, bleedUsable, bleedUpdate, bleedAdd } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      checkList: [],
      value: true,
      isLink: false,
      hemorrhageInfo: {
        bleedName: '',
        bleedIn: '',
        bleedOut: '',
        bleedTop: '',
        bleedBottom: ''
      },
      rules: {
        bleedName: [{
          required: true,
          message: '请填写出血类型'
        }]
      }
    }
  },
  created () {
    this.getEditInfo()
  },
  methods: {
    getEditInfo () {
      bleedDetail(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.hemorrhageInfo.bleedName = res.data.data.bleedName
          this.hemorrhageInfo.bleedIn = res.data.data.bleedIn
          this.hemorrhageInfo.bleedOut = res.data.data.bleedOut
          this.hemorrhageInfo.bleedTop = res.data.data.bleedTop
          this.hemorrhageInfo.bleedBottom = res.data.data.bleedBottom
        }
      })
    },
    getCompound () {
      this.isLink = !this.isLink
    },
    bindValue (val) {
      if (this.isLink) {
        this.hemorrhageInfo.bleedBottom = val
        this.hemorrhageInfo.bleedTop = val
        this.hemorrhageInfo.bleedIn = val
        this.hemorrhageInfo.bleedOut = val
      }
    },
    addBleed () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let _this = this
          if (this.$route.query.id) {
            bleedUsable({
              act: 1,
              bleedId: this.$route.query.id,
              bleedName: this.hemorrhageInfo.bleedName
            }).then((res) => {
              if (res.data.success) {
                bleedUpdate({ bleedId: _this.$route.query.id, spuBleedVo: _this.hemorrhageInfo }).then((res) => {
                  if (res.data.success) {
                    _this.$message.success('编辑成功')
                    _this.$router.push('./hemorrhage')
                  }
                })
              } else {
                this.$message.warning('出血类型已存在')
                this.$refs.inputRef.focus()
              }
            })
          } else {
            bleedUsable({
              act: 0,
              bleedId: '',
              bleedName: this.hemorrhageInfo.bleedName
            }).then((res) => {
              if (res.data.success) {
                bleedAdd(_this.hemorrhageInfo).then((res) => {
                  if (res.data.success) {
                    _this.$message.success('添加成功')
                    _this.$router.push('./hemorrhage')
                  } else {
                    this.$message.warning(res.data.message[0])
                  }
                })
              } else {
                this.$message.warning('出血类型已存在')
                this.$refs.inputRef.focus()
              }
            })
          }
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }
    .el-input {
      width: 110px;
    }
    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;
    i {
      font-size: 20px;
      color: #999;
    }
  }
  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;
    i {
      color: #fff;
    }
  }
}
</style>
